import { render, staticRenderFns } from "./Unmatched.vue?vue&type=template&id=6ffae5bd&scoped=true"
import script from "./Unmatched.vue?vue&type=script&lang=js"
export * from "./Unmatched.vue?vue&type=script&lang=js"
import style0 from "./Unmatched.vue?vue&type=style&index=0&id=6ffae5bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffae5bd",
  null
  
)

export default component.exports